import { render, staticRenderFns } from "./noPermissionView.vue?vue&type=template&id=1246a40f&scoped=true"
import script from "./noPermissionView.vue?vue&type=script&lang=js"
export * from "./noPermissionView.vue?vue&type=script&lang=js"
import style0 from "./noPermissionView.vue?vue&type=style&index=0&id=1246a40f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1246a40f",
  null
  
)

export default component.exports